import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import Availability from '../../ProductAvailability'

const StyledRoot = styled.div(() => ({
  flex: '1 1 auto',
}))

const StyledText = styled.p(({ theme: { fontSize } }) => ({
  margin: 0,
  fontSize: fontSize * 0.875,
  lineHeight: `${fontSize}px`,
  fontWeight: '800',
}))

const ProductAvailability = ({ availability }) => (
  <StyledRoot data-test="ProductAvailability">
    <StyledText>
      <Availability availability={availability} />
    </StyledText>
  </StyledRoot>
)

ProductAvailability.propTypes = {
  availability: PropTypes.string,
}

ProductAvailability.defaultProps = {
  availability: '',
}

export default React.memo(ProductAvailability)
